window.uetq = window.uetq || [];
window.uetq.push('consent', 'default', {'ad_storage': 'denied'});

class Usercentrics {

  static init () {
    if (window.UC_UI && window.UC_UI.isInitialized()) {
      if(document.querySelectorAll('[data-uc="1"]').length) {
        window.UC_UI.closeCMP();
      }
    } else {
      window.addEventListener('UC_UI_INITIALIZED', function(e) {

        if(document.querySelectorAll('[data-uc="1"]').length) {
          window.UC_UI.closeCMP();
        }
      });
    }
  }

  static handleYoutube () {

    window.addEventListener('ucEvent', function (e) {
      if(e.detail && e.detail.event === 'consent_status') {
        // microsoft ads consent mode
        let state = e.detail['Microsoft Advertising'] ? 'granted' : 'denied';
        window.uetq.push('consent', 'update', {'ad_storage': state});

        window.ytallowed = e.detail['YouTube Video'];

        const videos = document.getElementsByClassName('video-wrapper');

        if(videos.length){
          import("../contentelements/video").then(({default: VideoJs})=>{
            for(let video of videos) {
              VideoJs.initVideoJs(video)
            }
            window.addEventListener('scroll', ()=>{
              for(let video of videos) {
                VideoJs.initVideoJs(video)
              }
            }, {passive: true})
          })
        }
      }
    });
  }
}

export {
  Usercentrics
}